import enUS from './en-US';
import esES from './es-ES';

export const localeOptions = [
  { value: 'en-US', label: 'English' },
  { value: 'es-ES', label: 'Spanish' },
];
export default {
  'en-US': enUS,
  'es-ES': esES,
};
